
import Stats from 'stats.js';

export default class Statistics {
    constructor() {
        this.stats = new Stats();
        this.stats.showPanel(0);
        this.stats.dom.style.top = 'initial';
        this.stats.dom.style.bottom = '0px';
        document.body.appendChild(this.stats.dom);
    }

    begin() {
        this.stats.begin();
    }

    end() {
        this.stats.end();
    }
}